import React from 'react'
import Page from '../../layouts/Page'
import Container from './Container'
import { FormattedMessage, useIntl } from 'react-intl'

const Influencers = () => {
  const intl = useIntl()
  return (
    <Page
      title={<FormattedMessage id="my_creators" defaultMessage={"My Creators"} />}
      description={intl.formatMessage({ id: "my_creators_desc", defaultMessage: "View all the creators you’ve worked with or are currently collaborating with." })}
      breadcrumbs={[
        {
          title: <FormattedMessage id="influencee" defaultMessage={"influencee"} />,
          link: "/"
        },
        {
          title: <FormattedMessage id="my_creators" defaultMessage={"My Creators"} />,
          link: "/influencers"
        },
        
      ]}
    >
      <Container />
    </Page>
  )
}

export default Influencers